import { IAcademyEmail, IAcademyLink, IAcademyPhone } from '@sdk/contracts';
import { useTranslation } from 'react-i18next';

import { PurpleIconWrapper, WidgetTitle, WidgetWrapper } from '../shared/WidgetShared.styles';

import { LinkRow } from './components/LinkRow';
import { PhoneRow } from './components/PhoneRow';
import { TitleWrapper, Wrapper } from './ContactWidget.styles';

import WHATSAPP_ICON from '@/assets/logo_whatsapp.svg';
import { Icon } from '@/components/Icon';
import { useAcademy, useProfile } from '@/store';

const DEFAULT_WHATSAPP = '+34 636 34 54 50';
const DEFAULT_WHATSAPP_URL = 'https://wa.me/+34636345450';

export const ContactWidget: React.FC = () => {
  const { t } = useTranslation('StudentDashboardTranslations');
  const { profile } = useProfile();

  const { academy } = useAcademy(profile?.academy?._id);

  return (
    <WidgetWrapper>
      <WidgetTitle>{t('CONTACT_WIDGET_TITLE')}</WidgetTitle>
      <Wrapper>
        <TitleWrapper>
          <PurpleIconWrapper>
            <Icon i="Chat" color="purple7" />
          </PurpleIconWrapper>
          <span>{t('CHAT_CONTACT_LABEL')}</span>
        </TitleWrapper>
        {academy?.contactInfo?.emails?.map(({ email, info }: IAcademyEmail, index: number) => (
          <TitleWrapper key={email || index}>
            <PurpleIconWrapper>
              <Icon i="Email" color="purple7" />
            </PurpleIconWrapper>
            <a href={`mailto:${email}`}>
              {email} {info ?? ''}
            </a>
          </TitleWrapper>
        ))}
        <TitleWrapper>
          <PurpleIconWrapper>
            <img src={WHATSAPP_ICON} alt="Whatsapp" />
          </PurpleIconWrapper>
          <a href={`${DEFAULT_WHATSAPP_URL}`} target="_blank" rel="noopener noreferrer">
            {DEFAULT_WHATSAPP}
          </a>
        </TitleWrapper>
        {academy?.contactInfo?.phone?.map((phone: IAcademyPhone) => (
          <PhoneRow key={`${phone.prefix}-${phone.number}-${phone.info}`} {...phone} />
        ))}
        {academy?.contactInfo?.links?.map((link: IAcademyLink) => (
          <LinkRow key={`${link.link}-${link.info}`} {...link} />
        ))}
      </Wrapper>
    </WidgetWrapper>
  );
};
